import { Theme } from '@chakra-ui/react'

import getAccessibilityGlobalCSS from './class/accessibility'
import getChakraCSS from './class/chakra'
import getGlobalTextCSS from './class/textCSS'
import getOpenLayersCSS from './class/openLayers'

type Params = {
  theme: Theme
  colorMode: 'light' | 'dark'
}

const global = ({ theme, colorMode }: Params) => {
  const isLightMode = colorMode === 'light'

  const acessibilityCSS = getAccessibilityGlobalCSS(theme, isLightMode)
  const chakraCSS = getChakraCSS()
  const openLayersCSS = getOpenLayersCSS()
  const textCSS = getGlobalTextCSS()

  const scrollBg = isLightMode ? theme.colors.gray[200] : theme.colors.gray[700]
  const scrollColor = isLightMode ? theme.colors.gray[400] : theme.colors.gray[800]

  return {
    '*': {
      boxSizing: 'border-box',
      margin: 0,
      padding: 0,
      // scrollbarWidth: 'thin',
      scrollbarColor: scrollColor,
    },
    '*::-webkit-scrollbar': {
      width: '10px',
    },
    '*::-webkit-scrollbar-track': {
      background: scrollBg,
    },
    '*::-webkit-scrollbar-thumb': {
      backgroundColor: scrollColor,
      borderRadius: '12px',
      border: `3px solid ${scrollBg}`,
    },
    body: {
      // overflow: 'hidden',
    },

    '.treemap': {
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%',
      height: '500px',
      border: '2px solid #333',
      background: '#f9f9f9',
    },

    '.treemap-item': {
      position: 'relative',
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'white',
      fontSize: '1rem',
      fontWeight: 'bold',
      textAlign: 'center',
      padding: '5px',
    },

    '.treemap-item:nth-child(4n+1)': {
      backgroundColor: '#3498db',
    },

    '.treemap-item:nth-child(4n+2)': {
      backgroundColor: '#e74c3c',
    },

    '.treemap-item:nth-child(4n+3)': {
      backgroundColor: '#2ecc71',
    },

    '.treemap-item:nth-child(4n+4)': {
      backgroundColor: '#f1c40f',
    },

    '.treemap-item span': {
      position: 'absolute',
      bottom: '5px',
      right: '5px',
      fontSize: '0.8rem',
    },

    '#full-page-quill .ql-toolbar': {
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: 'bgContent',
    },

    '#full-page-quill .ql-container': {
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: 'bgContainer',
      minHeight: '1000px',
      padding: '20px 0px',
    },

    '#full-page-quill .ql-editor': {
      width: '60%',
      backgroundColor: 'bgContent',
    },

    ...acessibilityCSS,
    ...chakraCSS,
    ...openLayersCSS,
    ...textCSS,
  }
}

export default global
